export default __webpack_public_path__ + "static/media/syncIconForTable.def4ae00.svg";